import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PhotoDto } from '../../../../models/trofaco/photoDto';
import { MapLocation } from '../../../core/components/map-picker/map-picker.component';
import { DomSanitizer } from '@angular/platform-browser';
// @ts-ignore
import { EXIF as exifShim, EXIFStatic } from 'exif-js/exif';
import { PhotoCollectionService } from '../../../core/services/photo-collection.service';
import { CanDeactivateService } from 'src/app/modules/core/services/can-deactivate.service';

var EXIF: EXIFStatic = exifShim;

@Component({
    selector: 'app-upload-wizard',
    templateUrl: './upload-wizard.component.html',
    styles: []
})
export class UploadWizardComponent implements OnInit {

    get files(): File[] {
        return this._files;
    }

    @Input()
    set files(value: File[]) {
        this._files = value;
        this.setCurrentPhoto(0);
    }

    @Input()
    collectionId: string;

    @Input()
    defaultMapLocation: MapLocation;

    currentIndex: number;
    private _files: File[];

    photo: PhotoDto;

    showValidation = false;

    @Output()
    close = new EventEmitter();
    @Output()
    photoUploaded = new EventEmitter<PhotoDto>();

    constructor(
        private sanitizer: DomSanitizer, 
        private canDeactivateService: CanDeactivateService,
        private collectionService: PhotoCollectionService) {
    }

    ngOnInit() {
    }

    isPhotoValid() {
        return this.photo.lat && this.photo.lon;
    }

    async save(): Promise<PhotoDto | undefined> {
        if (!this.isPhotoValid()) {
            this.showValidation = true;
            return undefined;
        }

        let file = this._files[this.currentIndex];
        let photo = await this.collectionService.uploadCollectionPhoto(file,
            this.collectionId,
            <number>this.photo.lat,
            <number>this.photo.lon);
        this.showValidation = false;
        return photo;
    }

    async saveAndNextPhoto() {
        if (!this.isPhotoValid()) {
            this.showValidation = true;
            return;
        }
        this.showValidation = false;

        let uploadedPhoto = await this.save();
        if (!uploadedPhoto) return;
        this.photoUploaded.emit(uploadedPhoto);

        this.currentIndex++;
        if (this.currentIndex < this.files.length) {
            await this.setCurrentPhoto(this.currentIndex);
        } else {
            this.closeWizard();
        }
    }

    async setCurrentPhoto(index: number) {
        this.currentIndex = index;
        let file = this._files[index];
        const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));

        let exifTags = await this.extractExif(file);
        let photoLocation = this.convertExifToMapLocation(exifTags);
        let newPhoto: PhotoDto = {originalUrl: url};
        if (photoLocation) {
            newPhoto = {...newPhoto, lat: photoLocation.lat, lon: photoLocation.lng};
        }
        this.photo = newPhoto;
    }

    extractExif(file: File): Promise<any> {
        return new Promise<any>(resolve => {
            EXIF.getData(file, function () {
                resolve(EXIF.getAllTags(this));
            });
        });
    }

    convertExifToMapLocation(tags: any): MapLocation | null {
        let latArray: number[] = tags.GPSLatitude;
        let lngArray: number[] = tags.GPSLongitude;
        let gpsLatitudeRef = tags.GPSLatitudeRef;
        let gpsLongitudeRef = tags.GPSLongitudeRef;
        if (!latArray || !lngArray || !gpsLatitudeRef || !gpsLongitudeRef) return null;

        let lat = this.convertExifFormatToDecimal(latArray, gpsLatitudeRef);
        let lng = this.convertExifFormatToDecimal(lngArray, gpsLongitudeRef);
        return {lat, lng};
    }

    convertExifFormatToDecimal(values: number[], direction: string) {
        let degrees = values[0];
        let minutes = values[1];
        let seconds = values[2];

        let dd = degrees + (minutes / 60) + (seconds / 3600);

        if (direction == 'S' || direction == 'W') {
            dd = dd * -1;
        }
        //clip to 6 decimal places
        return +dd.toFixed(6);
    }

    async closeWizard() {
        this.close.emit();
    }

    async showConfirmLeaving(){
        let leaveThePage = await this.canDeactivateService.showWarning();
        if(leaveThePage)
            this.closeWizard();
    }
}
